module.exports = __webpack_public_path__ + "static/media/ccna-introduction-to-networks.87eeeb38.png";